/**
 * Words for a command that was accepted (202) and then failed (CommandFailedEvent). The command names are the C#
 * `CommandType` values the Portal sends; anything else reads as "Die Änderung".
 */
const COMMAND_LABELS: Record<string, string> = {
  CorrectTimeEntry: 'Die Korrektur des Zeiteintrags',
  CreateTimeEntry: 'Das Nachtragen des Zeiteintrags',
  DeleteTimeEntry: 'Das Stornieren des Zeiteintrags',
  SetBreakMinutes: 'Das Anpassen der Pause',
  StopTracking: 'Das Beenden des Zeiteintrags',
  UpdateEmployee: 'Das Speichern der Person',
  AnonymiseEmployee: 'Das Anonymisieren der Person',
  CreateShift: 'Das Anlegen der Schicht',
  UpdateShift: 'Das Ändern der Schicht',
  DeleteShift: 'Das Löschen der Schicht',
  CreateShiftTemplate: 'Das Anlegen der Vorlage',
  UpdateShiftTemplate: 'Das Ändern der Vorlage',
  DeleteShiftTemplate: 'Das Entfernen der Vorlage',
  ApproveAbsence: 'Das Genehmigen der Abwesenheit',
  RejectAbsence: 'Das Ablehnen der Abwesenheit',
  CancelAbsence: 'Das Zurückziehen der Abwesenheit',
  UpdateAbsence: 'Das Ändern der Abwesenheit',
  DeleteAbsence: 'Das Löschen der Abwesenheit',
  DecideShiftSwap: 'Die Entscheidung über den Schichttausch',
  CancelShiftSwap: 'Das Zurückziehen des Schichttauschs',
  DecideTimeCorrection: 'Die Entscheidung über den Korrekturantrag',
  CancelTimeCorrection: 'Das Zurückziehen des Korrekturantrags',
};

const REASON_TEXTS: Record<string, string> = {
  not_found: 'Der Eintrag existiert nicht mehr. Die Liste wurde nicht verändert.',
  conflict: 'Die Änderung kollidiert mit einer anderen, zum Beispiel einer Überschneidung oder einer schon getroffenen Entscheidung.',
  month_closed: 'Der Monat ist abgeschlossen.',
  forbidden: 'Dafür fehlt die Berechtigung.',
  invalid: 'Die Angaben ergeben keine gültige Änderung.',
  error: 'Auf dem Server ist ein Fehler aufgetreten, auch nach mehreren Versuchen.',
};

/** "Das Stornieren des Zeiteintrags" for 'DeleteTimeEntry'; "Die Änderung" for a command the Portal has no words for. */
export function commandLabel(commandType: string): string {
  return COMMAND_LABELS[commandType] ?? 'Die Änderung';
}

/** One sentence for the toast: what failed and why. */
export function commandFailureText(commandType: string, reason: string): string {
  const why = REASON_TEXTS[reason] ?? 'Ein Grund wurde nicht genannt.';
  return `${commandLabel(commandType)} wurde nicht ausgeführt. ${why}`;
}
